module.exports = __webpack_public_path__ + "media/images/email/tiktok-cdff94cfe821bd08e1e906825442e3a5.svg";